/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityLookalikesAggResult
 */
export interface MonitEntityLookalikesAggResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitEntityLookalikesAggResult
     */
    homoglyphs?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityLookalikesAggResult
     */
    total?: number;
}

/**
 * Check if a given object implements the MonitEntityLookalikesAggResult interface.
 */
export function instanceOfMonitEntityLookalikesAggResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityLookalikesAggResultFromJSON(json: any): MonitEntityLookalikesAggResult {
    return MonitEntityLookalikesAggResultFromJSONTyped(json, false);
}

export function MonitEntityLookalikesAggResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityLookalikesAggResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'homoglyphs': !exists(json, 'homoglyphs') ? undefined : json['homoglyphs'],
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function MonitEntityLookalikesAggResultToJSON(value?: MonitEntityLookalikesAggResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'homoglyphs': value.homoglyphs,
        'total': value.total,
    };
}

